import { ConfigurationIntermediateShelfSampleProcessAssignmentResponse } from '@/modules/configurationModule/detail/automation/grossing-shelf/intermediate-shelf-process/services/configuration-intermediate-shelf-sample-process-assignment/configuration-intermediate-shelf-sample-process-assignment.dto'

export interface ConfigurationAutomationGrossingShelfIntermediateShelfProcessModalState {
    intermediateShelfSampleProcessAssignment: Partial<ConfigurationIntermediateShelfSampleProcessAssignmentResponse>
}
export const initialConfigurationAutomationGrossingShelfIntermediateShelfProcessModalState =
    (): ConfigurationAutomationGrossingShelfIntermediateShelfProcessModalState => ({
        intermediateShelfSampleProcessAssignment: {}
    })
